import React, { useContext, useRef } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { toJS } from 'mobx'
import { useDraggable } from '@dnd-kit/core'
import { Button } from 'antd' // Importez le composant Button d'Ant Design
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../../../store/store.Builder'
import RenderedField from '../../../AvailableFields/RenderedField'
import styles from './FieldSortable.module.css'

const FieldSortable = observer(({ id, index, field }) => {
  const builderContext = useContext(BuilderContext)
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      data: {
        index,
        id,
        field,
      },
      disabled: field.isASubField || builderContext.isEditingText,
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div className={styles.container__a__field}>
      <div
        id={id}
        className={`${styles.field}`}
        ref={(element) => {
          setNodeRef(element)
        }}
        style={style}
        {...attributes}
        {...listeners}
      >
        <RenderedField index={index} field={field} listeners={listeners} />
      </div>
    </div>
  )
})

export default FieldSortable
